import SettingsManager from '../../layout/admin/SettingsManager';

export default function Settings() {
  return (
    <>
      <div className="flex-colomn gap-2">
        <SettingsManager />
      </div>
    </>
  );
}
